import React, {FC} from "react"
import {withTheme, DefaultTheme} from "styled-components"

import Flex from "@irati/ui/src/Flex"
import {Label} from "@irati/ui/src/Typography"
import {FormattedCurrency} from "@irati/utils/lang"

interface Props {
  value?: string
  theme: DefaultTheme
  isCurrencySaving?: boolean
  currency?: string
}

const OldAmount: FC<Props> = ({value, theme, isCurrencySaving, currency}) => {
  if (!value) {
    return null
  }

  const displayedValue = isCurrencySaving ? <FormattedCurrency value={value} currency={currency} isCents={false} /> : `${value}%`

  return (
    <Flex padding={`${theme.spacing.oneAndHalf} 0px`} direction="column" justifyContent="flex-end" marginLeft>
      <Label large textDecoration="line-through">
        {displayedValue}
      </Label>
    </Flex>
  )
}

export default withTheme(OldAmount)
